import { STEPPER_GLOBAL_OPTIONS, StepperOrientation } from '@angular/cdk/stepper';
import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import * as L from 'leaflet';
import { LeafletDirective } from '@asymmetrik/ngx-leaflet';
import { AppService } from 'src/app/shared/services/app.service';
import { AddMunicipalitiesService } from './add-municipalities.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import {map} from 'rxjs/operators';


const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-add-municipalities',
  templateUrl: './add-municipalities.component.html',
  styleUrls: ['./add-municipalities.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }
  }]
})
export class AddMunicipalitiesComponent implements OnInit {
  @ViewChild('stepper', { static: false }) private myStepper: MatStepper;
  @ViewChild(LeafletDirective, { static: false }) private leafletDirective: LeafletDirective;


  @Input() initialData: any;



  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;

  map: L.Map;
  mapInit: L.MapOptions
  mapLayer = []
  mapZoom: number;
  mapCenter: L.LatLng;
  geoJSON: L.GeoJSON;

  // cityCenterZoom: number;

  geojsonFeature: any = {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "id": "Multipolygon",
      "properties": { "name": "Multipolygon" },
      "geometry": { "type": "", "coordinates": "" }
    }]
  }
  zoomLevel: number;

  regions = []



  map1Options: any;
  private map1: L.Map;
  // private map2: L.Map;

  // Properties for map2
  map2: L.Map;
  map2Options: any;
  mapLayer2 = [];
  mapZoom2: number = 10;
  mapCenter2: L.LatLng;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private zone: NgZone,
    private appService: AppService,
    private addMunicipulitiesService: AddMunicipalitiesService,
    private toast: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute


  ) { }

  ngOnInit() {

    this.regions = this.route.snapshot.data['regions'];
    console.log("regions@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@_________");
    console.log(this.regions);


    // this.fetchRegions()
    // console.log("this.appService.loggedUser__________________________________________");
    // console.log(this.appService.loggedUser.uuid);

    // console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!this.initialData___________________________________________________________!!!");
    // console.log(this.initialData);

    // console.log(this.initialData.city.center.zoom);

    this.firstFormGroup = this._formBuilder.group({
      name: [this.initialData ? this.initialData.account[0].name : '', Validators.required],
      surname: [this.initialData ? this.initialData.account[0].surname : '', Validators.required],
      email: [this.initialData ? this.initialData.account[0].email : '', [Validators.required, Validators.email]],
      phone: [this.initialData ? '6984136441' : '', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      departmentName: [this.initialData ? this.initialData.account[0].cityAdmin[0].name : '', Validators.required],
      municipalityUri: [this.initialData ? this.initialData.city.municipality_URI : '', Validators.required]
    });

    this.secondFormGroup = this._formBuilder.group({
      region: [this.initialData ? this.initialData.city.administrative_region : '', Validators.required],
      municipality: [this.initialData ? this.initialData.city.municipality : '', Validators.required],
      address: [{ value: this.initialData ? this.initialData.account[0].cityAdmin[0].address : '', disabled: this.initialData ? false : true }, Validators.required],
      center: [this.initialData ? this.initialData.city.center : null, Validators.required],
      // zoom: [this.initialData ? this.initialData.city.center.zoom : '', Validators.required]
    });

    this.thirdFormGroup = this._formBuilder.group({

      center: [this.initialData ? this.initialData.city.center : '', Validators.required],
      latitude: [{ value: this.initialData ? this.initialData.city.center.coordinates[0] : '', disabled: true }, Validators.required],
      longitude: [{ value: this.initialData ? this.initialData.city.center.coordinates[1] : '', disabled: true }, Validators.required],
      zoom: [{ value: this.initialData ? this.initialData.city.center.zoom : '10' ,disabled: true}, Validators.required],

      // address: [{ value: this.initialData ? this.initialData.account[0].cityAdmin[0].address : '', disabled: this.initialData ? false : true }, Validators.required],


    });

    // if (!this.initialData) {
    //   this.fetchRegions();
    // }


    if (this.initialData) {
      // alert('initial data!!!!!!!!!')
      // console.log("this.initialData  999");
      // console.log(this.initialData);
      // console.log("this.initialData.city.center.zoom___");
      // console.log(this.initialData.city.center.zoom);


      this.thirdFormGroup.patchValue({ zoom: this.initialData.city.center.zoom });
      // alert("this.initialData.city.center.zoom_______")
      // alert(this.initialData.city.center.zoom)



      let cityCenterLat = this.initialData.city.center.coordinates[0];
      let cityCenterLong = this.initialData.city.center.coordinates[1];
      this.pointOnMap2(cityCenterLong, cityCenterLat);

      // console.log("this.initialData_______ooooooooooooo");
      // console.log(this.initialData);

      let cityAdminLat = this.initialData.account[0].cityAdmin[0].loc.coordinates[0];
      let cityAdminLong = this.initialData.account[0].cityAdmin[0].loc.coordinates[1];


      this.pointOnMap(cityAdminLong, cityAdminLat);

      // console.log("this.regions+++++++++++++++++++++");
      // console.log(this.regions);


      // Find the index of the region in regions array
      this.regionSelectedIndex = this.regions.findIndex(region => {
        return region.region === this.initialData.city.administrative_region;
      });


      this.regionSelectedIndex = this.regionSelectedIndex;
      this.municipalities = (this.regions[this.regionSelectedIndex]).municipalities;


    }





    // comment 2
    this.secondFormGroup.get('region').valueChanges.subscribe(value => {
      // alert("      this.secondFormGroup.get('region').valueChanges     ")
      if (value) {
        // this.secondFormGroup.patchValue({ municipality: this.initialData.city.municipality });
        // this.secondFormGroup.patchValue({ region: this.initialData.city.administrative_region });

        // if (!this.initialData) {
        // alert("1");
        this.secondFormGroup.get('municipality').setValue(''); // Reset the value

        // }

        this.clearMapPoint();
        this.secondFormGroup.get('municipality').enable();

        // Set map zoom and center to initial values
        this.mapZoom = 6;
        this.mapCenter = L.latLng(38.8116502, 23.0348969);
      } else {
        this.secondFormGroup.get('municipality').disable();
        this.secondFormGroup.get('address').disable();

        // if (!this.initialData) {
        // alert("2");

        this.secondFormGroup.get('municipality').setValue(''); // Reset the value
        this.secondFormGroup.get('address').setValue('');

        // }
        // this.secondFormGroup.get('municipality').setValue('');
        // this.secondFormGroup.get('address').setValue('');
      }
    });


    //  comment 1

    this.secondFormGroup.get('municipality').valueChanges.subscribe(value => {
      // alert("     this.secondFormGroup.get('municipality').valueChanges    ")

      if (value) {
        this.secondFormGroup.get('address').enable();
        this.clearMapPoint();
        this.mapLayer2 = [];


        this.secondFormGroup.get('address').enable();
        // if (!this.initialData) {
        this.fetchCityBoundaries(); // Fetch boundaries with current zoom level
        // }
        // Clear address and center fields
        // if (!this.initialData) {
        this.secondFormGroup.patchValue({ address: '', center: [] });
        // }
      } else {
        this.secondFormGroup.get('address').disable();
        this.secondFormGroup.get('address').setValue('');
      }
    });

    // Custom validation for stepper
    this.secondFormGroup.setValidators(this.customValidator());
    this.thirdFormGroup.setValidators(this.customValidatorStep3());




    this.secondFormGroup.get('address').valueChanges.subscribe(() => {
      this.secondFormGroup.updateValueAndValidity();
    });

    this.secondFormGroup.get('center').valueChanges.subscribe(() => {
      this.secondFormGroup.updateValueAndValidity();
    });





    this.map1Options = {
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
      ],
      zoom: 6,
      center: L.latLng(38.8116502, 23.0348969)
    };

    this.map2Options = {
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
      ],
      zoom: this.mapZoom2,
      center: L.latLng(38.8116502, 23.0348969)
    };
  }

  regionSelectedIndex: number = 0;
  municipalities = [];

  changeSelectedRegion(index) {
    console.log(index);
    this.regionSelectedIndex = index;

    console.log("--------------------");
    console.log(this.regions[index]);

    this.municipalities = (this.regions[index]).municipalities;
    // this.municipalities = (this.regions[2]).municipalities;

    console.log("this.municipulities____________");
    console.log(this.municipalities);




  }

  ngAfterViewInit() {
    // console.log("panagiotis");
    // console.log(this.myStepper);

    this.myStepper.selectionChange.subscribe(event => {
      console.log("event)))))))))))))))))))))");
      console.log(event);

      if (event.selectedIndex === 1) {
        // this.initializeMap();

        // if (this.initialData) {
        // this.secondFormGroup.patchValue({ municipality: this.initialData.city.municipality });
        // this.secondFormGroup.patchValue({ region: this.initialData.city.administrative_region });
        // }
      } else if (event.selectedIndex === 2) {

        // alert(" 22222222222222")
        // this.initializeMap();


        this.fetchCityBoundaries2(this.mapCenter2, this.mapZoom2);

      }


    });

    // console.log("8888888888888888888888888888888888888888888888");
    // console.log("this.secondFormGroup______________");
    // console.log(this.secondFormGroup.value);




  }



  pointOnMap(lat, lng) {
    console.log("lat,lng_____________________");
    console.log(lat, lng);


    this.mapCenter = L.latLng(lat, lng);
    // this.mapZoom = this.zoomLevel;

    // console.log("this.mapLayer_______");
    // console.log(this.mapLayer);

    this.mapLayer = [];

    this.mapLayer.push(L.marker([lat, lng], {
      icon: L.icon({
        iconAnchor: [12, 41],
        iconUrl: "assets/marker-icon.png",
        shadowUrl: "assets/marker-shadow.png"
      })
    }))
    // this.fetchCityBoundaries(); // Fetch boundaries with current zoom level
    this.fetchCityBoundaries(this.mapCenter, this.mapZoom);
    this.secondFormGroup.patchValue({ center: [lng, lat] });
  }

  pointOnMap2(lat, lng) {
    this.mapCenter2 = L.latLng(lat, lng);
    // this.mapZoom2 = 10; // or set a default value

    this.mapLayer2 = [];
    this.mapLayer2.push(L.marker([lat, lng], {
      icon: L.icon({
        iconAnchor: [12, 41],
        iconUrl: "assets/marker-icon.png",
        shadowUrl: "assets/marker-shadow.png"
      })
    }));

    // this.fetchCityBoundaries2(this.mapCenter2, this.mapZoom2);
    this.fetchCityBoundaries2();


    // alert("pointOnMap2")
    // alert("this.mapZoom2")
    // alert(this.mapZoom2)

    this.thirdFormGroup.patchValue({ center: [lng, lat] });
  }

  addressToMap(address) {
    if (!this.secondFormGroup.get('municipality').value) {
      this.toast.error(this.translate.instant('Please select a municipality first.'));
    } else {
      if (address) {
        this.appService.get_coordinates(address).subscribe(
          data => {
            if (data.results.length > 0) {
              this.pointOnMap(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng)
              this.secondFormGroup.patchValue({ address: data.results[0].formatted_address });
            } else {
              this.toast.error(this.translate.instant('Please enter a valid address!'));
            }
          },
          error => {
            console.error(error)
            this.toast.error(this.translate.instant('Please enter a valid address!'));
          }
        )
      }
    }
  }

  // private async fetchRegions() {
  //   this.addMunicipulitiesService.getRegions().subscribe(
  //     data => {
  //       // console.log("data from getRegions!!!!!!!!!!!!!");
  //       // console.log(data);
  //       this.regions = data;

  //     },
  //     error => {
  //       console.error(error)
  //       this.toast.error(this.translate.instant('ERRORS.SECTOR_DEACTIVATED'))
  //     }
  //   )
  // }



  clearMapPoint() {
    this.mapLayer = []; // Clear layers
    this.mapCenter = undefined; // Clear center
    this.mapZoom = undefined; // Clear zoom
  }

  private async fetchCityBoundaries(center?: L.LatLng, zoom?: number) {
    const municipulityValue = this.secondFormGroup.get('municipality').value;
    // console.log('Municipulity Control Value:', municipulityValue);

    // console.log("city__________");
    // console.log(municipulityValue);

    this.addMunicipulitiesService.getCityBoundaries(municipulityValue).subscribe(
      data => {
        console.log("data.coordinates___________");
        let lat = data.coordinates[0][0][0][1];
        let long = data.coordinates[0][0][0][0];

        console.log(data.coordinates[0][0][0]);

        if (center && zoom) {
          this.mapCenter = L.latLng(center.lat, center.lng);
          this.mapZoom = zoom; // Set zoom to 10 if currentZoom is undefined
        } else {
          this.mapCenter = L.latLng(lat, long);
          this.mapZoom = 10; // Set zoom to 10 if currentZoom is undefined
        }



        if (data.coordinates.length === 0) {
          // this.toastr.warning(this.translationService.get_instant('DASHBOARD.CITY_BOUNDARIES_NOT_DEFINED'), this.translationService.get_instant('WARNING'), { timeOut: 8000, progressBar: true, enableHtml: true })
        } else {
          this.geojsonFeature.features[0].geometry = { "type": data.type, "coordinates": data.coordinates }
          this.geoJSON = L.geoJSON(this.geojsonFeature)
          this.mapLayer.push(this.geoJSON)
        }
      },
      error => {
        // this.toastr.error(this.translationService.get_instant('SERVICES_ERROR_MSG'), this.translationService.get_instant('ERROR'), { timeOut: 8000, progressBar: true, enableHtml: true })
      }
    )
  }

  private async fetchCityBoundaries2(center?: L.LatLng, zoom?: number) {
    const municipulityValue = this.secondFormGroup.get('municipality').value;
    console.log('Municipulity Control Value:', municipulityValue);

    console.log("city__________");
    console.log(municipulityValue);

    this.addMunicipulitiesService.getCityBoundaries(municipulityValue).subscribe(
      data => {


        // console.log("data.coordinates2222222222222222222222222222222222222___________");
        let lat = data.coordinates[0][0][0][1];
        let long = data.coordinates[0][0][0][0];

        console.log(data.coordinates[0][0][0]);

        if (center && zoom) {
          // console.log(" if (center && zoom)");

          // alert("zoom   1")
          // alert(zoom)
          // alert("this.initialData.city.center.zoom 22_______")
          // alert(this.initialData.city.center.zoom)

          this.mapCenter2 = L.latLng(center.lat, center.lng);

          let zoom_ = this.thirdFormGroup.get('zoom').value;

          // alert("zoom______________")
          // alert(zoom_)

          // this.mapZoom2 = this.initialData.city.center.zoom; // Set zoom to 10 if currentZoom is undefined

          this.mapZoom2 = zoom_
          this.thirdFormGroup.patchValue({ zoom: this.initialData.city.center.zoom });

          if (this.initialData) {
            this.thirdFormGroup.patchValue({ zoom: zoom })

          }

        } else {


          if (!this.initialData) {
            // alert("NOOOOOOOO if (center && zoom)")
            // console.log("NOOOOOOOO if (center && zoom)");
            this.thirdFormGroup.patchValue({ zoom: this.mapZoom2 })
            this.mapCenter2 = L.latLng(lat, long);
            // this.mapZoom2 = 10; // Set zoom to 10 if currentZoom is undefined
            // this.thirdFormGroup.patchValue({ latitude: lat })
            // this.thirdFormGroup.patchValue({ longitude: long })
          }



        }



        if (data.coordinates.length === 0) {
          // this.toastr.warning(this.translationService.get_instant('DASHBOARD.CITY_BOUNDARIES_NOT_DEFINED'), this.translationService.get_instant('WARNING'), { timeOut: 8000, progressBar: true, enableHtml: true })
        } else {
          this.geojsonFeature.features[0].geometry = { "type": data.type, "coordinates": data.coordinates }
          this.geoJSON = L.geoJSON(this.geojsonFeature)
          this.mapLayer2.push(this.geoJSON)
        }
      },
      error => {
        // this.toastr.error(this.translationService.get_instant('SERVICES_ERROR_MSG'), this.translationService.get_instant('ERROR'), { timeOut: 8000, progressBar: true, enableHtml: true })
      }
    )


  }



  private customValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const address = control.get('address').value;
      const center = control.get('center').value;
      // return address && center ? null : { incomplete: true };
      return address && center.length ? null : { incomplete: true };

    };
  }

  private customValidatorStep3(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const latitude = control.get('latitude').value;
      const longitude = control.get('longitude').value;
      const center = control.get('center').value;
      const zoom = control.get('zoom').value;

      // console.log("00000000000000000000000000000000000000000000000000000");
      // console.log(latitude);

      // console.log(longitude);
      // console.log(center);
      // console.log(zoom);




      // return address && center ? null : { incomplete: true };
      return latitude && longitude && center.length && zoom ? null : { incomplete: true };

    };
  }

  // test
  onMapReady1(map: L.Map) {
    this.map1 = map;
    this.initializeMap1(this.map1);
    // this.map1.on('click', (e: L.LeafletMouseEvent) => this.onMapClick(e, 'map1'));
    map.on("click", (ev: L.LeafletMouseEvent) => {
      this.zone.run(() => {
        if (!this.secondFormGroup.get('municipality').value) {
          this.toast.error(this.translate.instant('Please select a municipality first.'));
        } else {
          this.pointOnMap(ev.latlng.lat, ev.latlng.lng);

          this.appService.get_address(ev.latlng.lat, ev.latlng.lng).subscribe(
            data => {
              if (data.results.length > 0) {
                this.secondFormGroup.patchValue({ address: data.results[0].formatted_address });
              }
            },
            error => {
              console.error(error)
            }
          );
        }
      });
    })
  }

  onMapReady2(map: L.Map) {
    this.map2 = map;
    this.initializeMap2(this.map2);

    // this.map2.on('click', (e: L.LeafletMouseEvent) => this.onMapClick(e, 'map2'));
    map.on("click", (ev: L.LeafletMouseEvent) => {
      this.zone.run(() => {

        this.pointOnMap2(ev.latlng.lat, ev.latlng.lng);

        this.thirdFormGroup.patchValue({ latitude: ev.latlng.lat, longitude: ev.latlng.lng });
        this.thirdFormGroup.patchValue({ center: [ev.latlng.lng, ev.latlng.lat] });




      });
    })
  }

  initializeMap1(map: L.Map) {


    setTimeout(() => {
      this.map1 = this.leafletDirective.getMap();
      if (this.map1) {
        this.map1.invalidateSize();
        // Listen for zoom events
        this.map1.on('zoomend', () => {
          this.zoomLevel = this.map1.getZoom();
          // console.log('Current Zoom Level__________________:', this.zoomLevel);
          // this.secondFormGroup.patchValue({ zoom: this.zoomLevel });

        });
      }
    }, 0);
  }

  initializeMap2(map: L.Map) {
    // alert("  initializeMap2 !!!!!!!!!!!!!!!!!!!!!")
    setTimeout(() => {
      if (map) {
        map.invalidateSize();
        map.on('zoomend', () => {
          const zoomLevel = map.getZoom();
          // console.log('Current Zoom Level:', zoomLevel);

          // check it!!
          this.mapZoom2 = zoomLevel
          this.thirdFormGroup.patchValue({ zoom: zoomLevel });
          // console.log("this.thirdFormGroup__________________________________________12222");
          // console.log(this.thirdFormGroup);


        });


      }

    }, 0);
  }





  onCreateMunicipulity() {



    // console.log("form values to post!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

    // console.log(this.firstFormGroup.value);
    // console.log(this.secondFormGroup.value);

    // console.log("form values to post!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

    let municipulityData = {
      "name": this.firstFormGroup.value.name,
      "surname": this.firstFormGroup.value.surname,
      "email": this.firstFormGroup.value.email,
      "region": this.secondFormGroup.value.region,
      "municipality": this.secondFormGroup.value.municipality,
      "municipality_URI": this.firstFormGroup.value.municipalityUri,
      "nameCityAdminDepartment": this.firstFormGroup.value.departmentName,
      "addressDepartment": this.secondFormGroup.value.address,
      "locDepartment": this.secondFormGroup.value.center,

      "center": this.thirdFormGroup.value.center,
      "zoom": this.thirdFormGroup.get('zoom').value,




    }

    // console.log("municipulityData-------------------------------------------------------------------");
    // console.log(municipulityData);
    // console.log("municipulityData-------------------------------------------------------------------");

    this.addMunicipulitiesService.addMunicipulity(municipulityData).subscribe(
      data => {
        // console.log("data  addMunicipulity @@@@@@@@@@@@@@@@@");
        // console.log(data);


      }, error => {
        // console.log(error);
        this.toast.error(this.translate.instant('ERRORS.SERVICES_ERR'));


      }
    );




    // afou steilw ta data!!!!!!!
    // Reset form groups and clear validators
    this.firstFormGroup.reset();
    this.secondFormGroup.reset();

    Object.keys(this.firstFormGroup.controls).forEach(key => {
      this.firstFormGroup.get(key).setErrors(null);
    });

    Object.keys(this.secondFormGroup.controls).forEach(key => {
      this.secondFormGroup.get(key).setErrors(null);
    });

    // Clear map point
    this.clearMapPoint();

    // Reset stepper
    this.myStepper.reset();



    this.router.navigate(['admin', 'municipalities'])








  }
}





























